export const MINIMUM_DATE_RANGE_BOUND_DATE = new Date(1900, 1, 1)
